export default __webpack_public_path__ + "static/explore_4-7fc18ce2ec43689fd76a7aa53977cf72.png";